'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverContent = function (_Component) {
  _inherits(PopoverContent, _Component);

  function PopoverContent() {
    _classCallCheck(this, PopoverContent);

    return _possibleConstructorReturn(this, (PopoverContent.__proto__ || Object.getPrototypeOf(PopoverContent)).apply(this, arguments));
  }

  _createClass(PopoverContent, [{
    key: 'render',
    value: function render() {
      var position = this.props.position;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)(_styles2.default.popover, _styles2.default[position]),
          style: this._popoverPositioningStyle() },
        _react2.default.createElement(
          'div',
          { className: _styles2.default.content, style: this._contentStyle() },
          this.props.children
        )
      );
    }
  }, {
    key: '_popoverPositioningStyle',
    value: function _popoverPositioningStyle() {
      return {
        left: this.props.style.left,
        top: this.props.style.top
      };
    }
  }, {
    key: '_contentStyle',
    value: function _contentStyle() {
      var borderColor = this.props.shouldHaveBorder ? this.props.style.borderColor : 'transparent';

      return {
        border: '1px solid ' + borderColor,
        borderRadius: this.props.style.borderRadius + 'px',
        background: this.props.style.background,
        boxShadow: this.props.hasShadow ? '5px 5px 15px rgba(136, 136, 136, 0.44)' : null
      };
    }
  }]);

  return PopoverContent;
}(_react.Component);

PopoverContent.propTypes = {
  position: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
  shouldHaveBorder: _propTypes2.default.bool.isRequired,

  style: _propTypes2.default.shape({
    background: _propTypes2.default.string,
    borderColor: _propTypes2.default.string,
    borderRadius: _propTypes2.default.number,
    top: _propTypes2.default.any,
    left: _propTypes2.default.any
  }),
  hasShadow: _propTypes2.default.bool
};
PopoverContent.defaultProps = {
  position: 'top',
  style: {
    borderColor: '#ccc',
    background: 'white',
    borderRadius: 0,
    top: null,
    left: null
  },
  className: '',
  hasShadow: false
};
exports.default = PopoverContent;